import guid from '@/shared/utils/guid';

export const getCacheBustedFileUrl = (fileUrl: string, cacheBuster?: string): string => {
  if (fileUrl.startsWith('blob:')) {
    return fileUrl;
  }
  return `${fileUrl}?${cacheBuster || guid()}`;
};

export const mapSettingsData = (initialSettingsItems: { fieldName: string; key: string }[], settingsValues?: Record<string, any>) => {
  return initialSettingsItems.map((item) => ({
    fieldName: item.fieldName,
    value: settingsValues?.[item.key] ?? '',
    key: item.key
  }));
};
